import "../../Styles/dashboard/addproduct.css"
import {IoMdArrowBack} from "react-icons/io"
import {BsImage} from "react-icons/bs"
import { useState } from "react";
import { useNavigate } from "react-router";
import Sidebar from "../../components/dashboard/sidebar";

const Edit = () => {
    const navigate = useNavigate()
    
    const [previewImage, setPreviewImage] = useState(null);
    const [product, setProduct] = useState({
        name: "",
        description: "",
        category: "",
        originalPrice: "",
        discountPrice: "",
        HarvestDate: "",
        weight: "",
        SustainabilityPractice: ""
    })
    const [productFile, setProductFile] = useState()
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        setProductFile(file)

        if (file) {

        const reader = new FileReader();

        reader.onloadend = () => {
            setPreviewImage(reader.result);
        };

        reader.readAsDataURL(file);
        } else {
        setPreviewImage(null);
        }
    };
    const addProduct = () => {

    }
    const discard = (e) => {
        e.preventDefault()
        setPreviewImage(null)
    }

    return<>
        <Sidebar/>

        <div className="addProductWrapper">
            
            <div className="pageInfo">
                <IoMdArrowBack onClick={() => navigate("/dashboard/product")}/>
                <h2>Edit Product</h2>
            </div>

            <form action="" onSubmit={addProduct}>
                <div className="leftAdd">
                    <div className="baseInformation">
                        <h2>Base Information</h2>
                        <div className="inputWrapper">
                            <label htmlFor="">Product Name</label>
                            <input type="text" value={product.name} onChange={(e) => setProduct({...product, name: e.target.value})}/>
                        </div>
                        <div className="inputWrapper">
                            <label htmlFor="">Product Images</label>
                            <div className="inputs">
                            <input type="file" accept="image/*" onChange={handleImageChange}/>
                            </div>
                        </div>
                        <div className="inputWrapper">
                            <label htmlFor="">Description</label>
                            <textarea name="" id="" cols="30" rows="5" value={product.description} onChange={(e) => setProduct({...product, description: e.target.value})}></textarea>
                        </div>
                    </div>
                    <div className="details">
                        <h2>Details</h2>
                        <div className="inputWrapper">
                            <label htmlFor="">Category</label>
                            <input type="text" value={product.category} onChange={(e) => setProduct({...product, category: e.target.value})}/>
                        </div>
                        <div className="inputContainer">
                            <div className="inputWrapper">
                                <label htmlFor="">Harvest Date</label>
                                <input type="date" value={product.HarvestDate} onChange={(e) => setProduct({...product, HarvestDate: e.target.value})}/>
                            </div>
                            <div className="inputWrapper">
                                <label htmlFor="">Weight</label>
                                <input type="text" value={product.weight} onChange={(e) => setProduct({...product, weight: e.target.value})}/>
                            </div>
                        </div>
                        <div className="inputWrapper">
                            <label htmlFor="">Sustainability Practice</label>
                            <input type="text" value={product.SustainabilityPractice} onChange={(e) => setProduct({...product, SustainabilityPractice: e.target.value})}/>
                        </div>
                        <div className="inputContainer">
                            <div className="inputWrapper">
                                <label htmlFor="">Original Price</label>
                                <input type="text" value={product.originalPrice} onChange={(e) => setProduct({...product, originalPrice: e.target.value})}/>
                            </div>
                            <div className="inputWrapper">
                                <label htmlFor="">Discount Price</label>
                                <input type="text" value={product.discountPrice} onChange={(e) => setProduct({...product, discountPrice: e.target.value})}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttonWrapper">
                        <button type="submit" disabled={loading}>Save Product</button>
                        <button type="submit" onClick={disabled}>Discard</button>
                    </div>
                </div>

                <div className="rightAdd">
                    <div className="imageWrap">
                        <h2>Image Preview</h2>
                        <div className="image">
                            {previewImage  ?  <img src={previewImage} alt="" /> : <BsImage/>}
                        </div>
                    </div>
                </div>
            </form>
        </div>

    </>

}

export default Edit